import { cn } from '@/lib/utils/cn';

interface LogoProps {
  className?: string;
}

export const Logo = ({ className }: LogoProps) => (
  // `role="img"` + `aria-label` : le lecteur d'écran annonce « ubeefy » une
  // seule fois, au lieu d'épeler le contenu du SVG puis le texte.
  <span
    className={cn('inline-flex shrink-0 items-center', className)}
    role="img"
    aria-label="ubeefy"
  >
    <img
      src="/brand/ubeefy-wordmark.svg"
      alt=""
      aria-hidden="true"
      className="h-8 w-auto"
      width="134"
      height="40"
    />
  </span>
);
